/**
 * PLAN STORAGE - API Segura para Trading Plans
 * Utiliza endpoints en worker.js protegidos con JWT
 * ✅ Seguridad: Todas las queries se ejecutan en servidor
 */

class PlanStorage {
    constructor() {
        // Usar URL absoluta del worker en Cloudflare
        this.apiBase = 'https://trading-journal-preprod.monkeydfx-trader.workers.dev';
    }

    /**
     * Obtener token JWT del storage
     */
    getAuthToken() {
         const token = sessionStorage.getItem('authToken') || 
             sessionStorage.getItem('userToken') || 
             localStorage.getItem('authToken') || 
             localStorage.getItem('userToken');
        
        if (token) {
            try {
                const parts = token.split('.');
                if (parts.length === 3) {
                    JSON.parse(atob(parts[1]));
                }
            } catch (e) {}
        }
        
        return token;
    }

    /**
     * Hacer petición al API con JWT
     */
    async apiCall(endpoint, method = 'POST', body = null, silent = false) {
        const token = this.getAuthToken();
        
        if (!token) {
            throw new Error('❌ No authentication token found');
        }

        const url = `${this.apiBase}/api/plan/${endpoint}`;
        const options = {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        try {
            const response = await fetch(url, options);

            if (!response.ok) {
                let data = null;
                try {
                    data = await response.json();
                } catch (e) {
                    const text = await response.text();
                    data = { error: text };
                }
                const err = new Error(`HTTP ${response.status}: ${data?.error || 'Request failed'}`);
                err.status = response.status;
                err.data = data;
                throw err;
            }

            const data = await response.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Obtener plan de una cuenta
     */
    async getPlan(silent = false, accountId = null) {
        try {
            const effectiveAccountId = accountId || (typeof window !== 'undefined' ? window.currentAccount : null);
            const response = await this.apiCall('get', 'POST', { accountId: effectiveAccountId }, silent);
            return response.plan || null;
        } catch (error) {
            return null;
        }
    }

    /**
     * Crear nuevo plan
     */
    async createPlan(checkpointValues, accountId = null) {
        try {
            const effectiveAccountId = accountId || (typeof window !== 'undefined' ? window.currentAccount : null);
            const response = await this.apiCall('create', 'POST', { checkpointValues, accountId: effectiveAccountId });
            return response;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Actualizar plan existente
     */
    async updatePlan(checkpointValues, accountId = null) {
        try {
            const effectiveAccountId = accountId || (typeof window !== 'undefined' ? window.currentAccount : null);
            await this.apiCall('update', 'POST', { checkpointValues, accountId: effectiveAccountId });
            return true;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Borrar plan
     */
    async deletePlan(accountId = null) {
        try {
            const effectiveAccountId = accountId || (typeof window !== 'undefined' ? window.currentAccount : null);
            const response = await this.apiCall('delete', 'POST', { accountId: effectiveAccountId });
            return response;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Activar plan
     */
    async activatePlan(accountId) {
        try {
            return false;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Verificar si existe plan para la cuenta
     */
    async hasPlan(accountId) {
        try {
            const plan = await this.getPlan(false, accountId);
            return plan !== null;
        } catch (error) {
            return false;
        }
    }


}

// Instancia global
const planStorage = new PlanStorage();
if (typeof window !== 'undefined') {
    window.planStorage = planStorage;
}
